import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BackdropComponent } from './components/backdrop/backdrop.component';

@NgModule({
  declarations: [SpinnerComponent, BackdropComponent],
  imports: [CommonModule, ProgressSpinnerModule],
  exports: [SpinnerComponent, BackdropComponent],
})
export class SpinnerModule {}
